<template>
  <el-dialog title="批次信息"
             :visible.sync="visible"
             width="520px"
             @closed="handleClosed"
             :close-on-press-escape="false">
    <div class="info-title">企业名称：<span>{{ config.vendorName }}</span></div>
    <div class="info-title">产品名称：<span>{{ config.productName }}</span></div>
    <el-table border
              max-height="480px"
              v-loading="loading"
              :data="list">
      <el-table-column label="商品批次号"
                       min-width="180"
                       show-overflow-tooltip=""
                       prop="batchCode">
      </el-table-column>
      <el-table-column label="标签数量"
                       width="100"
                       show-overflow-tooltip=""
                       prop="tagCount">
      </el-table-column>
    </el-table>
    <span slot="footer">
      <el-button @click="visible = false"
                 :loading="loading">关闭</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  name: 'batch-modal',
  data () {
    return {
      loading: false,
      visible: false,
      config: { productName: '', vendorName: '' },
      list: []
    }
  },
  methods: {
    handleClosed () {
      this.config = { ...this.config, productName: '', vendorName: '' }
      this.list = []
    },
    fetch (options, list) {
      this.config = { ...this.config, ...options }
      this.list = list
      this.visible = true
    }
  }
}
</script>
<style lang="stylus" scoped>
.info-title {
  line-height: 20px;
  font-size: 14px;

  span {
    color: #333;
  }
}

.info-title +.info-title {
  margin-bottom: 10px;
}
</style>
